import isNode from "./is-node"

export default !isNode



// WEBPACK FOOTER //
// ./src/css.js